import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgModule } from '@angular/core';
import { RxAccordionComponent } from './rx-accordion.component';
import { RxIconModule } from '../rx-icon/rx-icon.module';

@NgModule({
  imports: [CommonModule, FormsModule, MatExpansionModule, RxIconModule, RxAccordionComponent],
  exports: [RxAccordionComponent],
})
export class RxAccordionModule {}
